module.exports = __webpack_public_path__ + "static/img/action-fx2.a6547026.png";